import { render, staticRenderFns } from "./HospitalIncidentsTable.vue?vue&type=template&id=248c658d&"
import script from "./HospitalIncidentsTable.vue?vue&type=script&lang=js&"
export * from "./HospitalIncidentsTable.vue?vue&type=script&lang=js&"
import style0 from "./HospitalIncidentsTable.vue?vue&type=style&index=0&id=248c658d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports